// App.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

function ThemeProvider({ children }) {
  const [theme, setTheme] = useState('light');
  const [count, setCount] = useState(0);

  // Count increases every second
  useEffect(() => {
    const interval = setInterval(() => setCount(c => c + 1), 1000);
    return () => clearInterval(interval);
  }, []);

  const value = { theme, setTheme }; // 👈 Without useMemo

  return (
    <ThemeContext.Provider value={value}>
      <div>
        <p>Counter: {count}</p>
        {children}
      </div>
    </ThemeContext.Provider>
  );
}

function ThemeDisplay() {
  const { theme } = useContext(ThemeContext);
  console.log('ThemeDisplay rendered');

  return <h2>Current theme: { theme }</h2>;
}

export default function App() {
  return (
    <ThemeProvider>
      <ThemeDisplay />
    </ThemeProvider>
  );
}
